// See https://www.typescriptlang.org/docs/handbook/unions-and-intersections.html#union-exhaustiveness-checking
export function assertUnreachable(x: never): never {
  throw new Error(`Unexpected object: ${x}`);
}
